__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/6a8e80b/_next/";